import React from 'react';
import { CloseCircleOutlined, CloseCircleFilled } from '@ant-design/icons';
import { Button } from 'antd';

interface DeleteButtonProps {
    api: any;
    node: any;
    onRowDelete: (deletedRow: number) => void;
}

const DeleteButtonComponent: React.FC<DeleteButtonProps> = ({ api, node, onRowDelete }) => {
    const onButtonClick = () => {
        if (window.confirm(`Are you sure you want to delete : ${node.data.policynumber?node.data.policynumber : node.data.name}?`)) {
            onRowDelete(node.rowIndex)
        }
      };
    
      return (
            <Button
            onClick={onButtonClick}
            className='ml-1'
            icon={<CloseCircleFilled style={{fontWeight: 'bold', fontSize: '16px', color: '#b91c1c'}}/>}
            style={{
                width: '20px',
                height: '20px',
                border: 'none',
                padding: 0,
                background: 'transparent',
                borderRadius: 0,
            }}
            >
                
            </Button>
      );
};

export default DeleteButtonComponent
